

// Import all yaml files from backend constants
let data = {};
const modules = import.meta.glob('../../backend/common/constants/*.yaml', { eager: true });
Object.values(modules).forEach((mod) => {
  data = Object.assign(data, mod.default);
});


data.COOKIE_EXPIRES_DAYS = 365;
data.MAX_PHOTO_PRE_CROP_DIMENSION = 1000;
data.ICON_SET_BLUEPRINT = "bp";
data.ICON_SET_FONTAWESOME = "fa";
data.ICON_SET_BOX = "box";

data.STRIPE_PUBLIC_KEY_LIVE = 'pk_live_iTRPcizk6MQ5b7ytGWjnuM5g';
data.STRIPE_PUBLIC_KEY_TEST = 'pk_test_luKElMx5V0INAhqgq8GPtaYY';
data.SENTRY_PUBLIC_DSN = 'https://2bc94d0f729341ffa221ba98a677448d@o102152.ingest.sentry.io/224575';
data.FACEBOOK_APP_ID = '1641515736101139';
data.ZENDESK_WEB_WIDGET_KEY = 'e682ef22-6544-432a-aaa1-09a611c33ce0';

data.TERMS_URL = `${data.HOME_URL}/terms`;
data.PRIVACY_URL = `${data.HOME_URL}/privacy`;

data.HELP_CENTER_URL = "https://help.onvoard.com";
data.API_DOCS_URL = "https://api-docs.onvoard.com";
data.ASK_SUPPORT_URL = "https://onvoard.com/contact";
data.WRITE_REVIEW_URL = "https://onvoard.com/write-review-for-onvoard";

data.BP_SVG_ICONS_URL = "https://cdn.onvoard.com/files/worki/icons/bp-icon.svg";
data.FA_SVG_ICONS_URL = "https://cdn.onvoard.com/files/worki/icons/fa-icon.svg";
data.BOX_SVG_ICONS_URL = "https://cdn.onvoard.com/files/worki/icons/box-icon.svg";

data.CALENDAR_VIEW_MONTH = 'MONTH';
data.CALENDAR_VIEW_WEEK = 'WEEK';
data.CALENDAR_VIEW_SCHEDULE = 'SCHEDULE';

data.DESERIALIZE_TYPE_MAP = 'MAP';
data.DESERIALIZE_TYPE_OBJECT = 'OBJECT';
data.DESERIALIZE_TYPE_ARRAY_OBJECTS = 'ARRAY_OBJECTS';
data.DESERIALIZE_TYPE_CUSTOM = 'CUSTOM';

data.COOKIE_ENGAGED_MARKETING_ACTIONS = 'ENGAGED_MARKETING_ACTIONS';

data.ADMIN_SIDEBAR = {
  'IMPORT_JOBS': 'IMPORT_JOBS',
  'EXPORT_JOBS': 'EXPORT_JOBS',
  'BACKGROUND_JOBS': 'BACKGROUND_JOBS',
  'RESOURCES': 'RESOURCES',
  'RESOURCE_ASSOCIATIONS': 'RESOURCE_ASSOCIATIONS',
  'DATA_MAPPINGS': 'DATA_MAPPINGS',
  'LOOKUP_TABLES': 'LOOKUP_TABLES',
  'TAXONOMY': 'TAXONOMY',

  'CATALOG': 'CATALOG',

  'ACCOUNTS': 'ACCOUNTS',
  'USERS_MANAGEMENT': 'USERS_MANAGEMENT',
  'CUSTOM_PAGES': 'CUSTOM_PAGES',
  'API_DETAILS': 'API_DETAILS',
  'WEBHOOKS': 'WEBHOOKS',
  'AFFILIATE_PROGRAM': 'AFFILIATE_PROGRAM',
  'PARTNER_OVERVIEW': 'PARTNER_OVERVIEW',

  'SUBSCRIPTIONS': 'SUBSCRIPTIONS',
  'USAGES': 'USAGES',
  'INVOICES': 'INVOICES',
  'CREDITS': 'CREDITS',
  'PARTNER_DEALS': 'PARTNER_DEALS',

  'CONTROL_ACCOUNTS': 'CONTROL_ACCOUNTS',
  'CONTROL_SUBSCRIPTIONS': 'CONTROL_SUBSCRIPTIONS',
  'CONTROL_USERS': 'CONTROL_USERS',
  'CONTROL_CONNECTIONS': 'CONTROL_CONNECTIONS',
  'CONTROL_COUPONS': 'CONTROL_COUPONS',
  'CONTROL_PARTNERS': 'CONTROL_PARTNERS',
  'CONTROL_AGENCIES': 'CONTROL_AGENCIES',
  'CONTROL_INTEGRATION_PARTNERS': 'CONTROL_INTEGRATION_PARTNERS',
  'CONTROL_EMAIL_TEMPLATES': 'CONTROL_EMAIL_TEMPLATES',
  'CONTROL_PROMPT_TEMPLATES': 'CONTROL_PROMPT_TEMPLATES',
  'CONTROL_SEGMENT_TEMPLATES': 'CONTROL_SEGMENT_TEMPLATES',
  'CONTROL_FLOW_PLAYBOOKS': 'CONTROL_FLOW_PLAYBOOKS',
  'CONTROL_WORKFLOW_PLAYBOOKS': 'CONTROL_WORKFLOW_PLAYBOOKS',
};

data.ECOMMERCE_SIDEBAR = {
  'ECOMMERCE_PRODUCTS': 'ECOMMERCE_PRODUCTS',
  'SHOPIFY_SETTINGS': 'SHOPIFY_SETTINGS',
  'BIGCOMMERCE_SETTINGS': 'BIGCOMMERCE_SETTINGS',
  'EASYSTORE_SETTINGS': 'EASYSTORE_SETTINGS',
  'SHOPLINE_SETTINGS': 'SHOPLINE_SETTINGS',
  'WIX_SETTINGS': 'WIX_SETTINGS',
  'WEB_TRACKING': 'WEB_TRACKING',
  'CONVERSION_SETTINGS': 'CONVERSION_SETTINGS',
};


data.ADMIN_MENU = {
  'DATA': 'DATA',
  'CATALOG': 'CATALOG',
  'SETTINGS': 'SETTINGS',
  'BILLING': 'BILLING',
  'CONTROL': 'CONTROL',
};


data.MARKETING_PLATFORM_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',

  'CONTACTS': 'CONTACTS',
  'CONTACT_LISTS': 'CONTACT_LISTS',
  'CONTACT_TAGS': 'CONTACT_TAGS',
  'CONTACT_SEGMENTS': 'CONTACT_SEGMENTS',
  'CONTACT_ACTIVITIES': 'CONTACT_ACTIVITIES',
  'CONTACT_PROPERTIES': 'CONTACT_PROPERTIES',
  'CONTACTS_BULK_ACTIONS': 'CONTACTS_BULK_ACTIONS',

  'EMAILS': 'EMAILS',
  'EMAIL_TEMPLATES': 'EMAIL_TEMPLATES',
  'BROADCASTS': 'BROADCASTS',
  'EMAIL_TAGS': 'EMAIL_TAGS',
  'EMAIL_DOMAINS': 'EMAIL_DOMAINS',
  'EMAIL_PROFILES': 'EMAIL_PROFILES',
  'EMAIL_SETTINGS': 'EMAIL_SETTINGS',
  'SMTP_PROFILES': 'SMTP_PROFILES',
  'EMAIL_SENDING_RULES': 'EMAIL_SENDING_RULES',
  'EMAIL_DELIVERY_STATS': 'EMAIL_DELIVERY_STATS',

  'WORKFLOWS': 'WORKFLOWS',
  'WORKFLOW_PLAYBOOKS': 'WORKFLOW_PLAYBOOKS',
  'CONNECTIONS': 'CONNECTIONS',
};

data.MARKETING_PLATFORM_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'CONTACTS': 'CONTACTS',
  'EMAILS': 'EMAILS',
  'ECOMMERCE': 'ECOMMERCE',
  'WORKFLOWS': 'WORKFLOWS',
  'CONNECTIONS': 'CONNECTIONS',
  'DATA': 'DATA',
};


data.AOV_PROGRESS_BAR_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',
  'CONNECTIONS': 'CONNECTIONS',
};

data.AOV_PROGRESS_BAR_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'ECOMMERCE': 'ECOMMERCE',
  'CONNECTIONS': 'CONNECTIONS',
};


data.BACK_IN_STOCK_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'INVENTORY': 'INVENTORY',
  'SUBSCRIBERS': 'SUBSCRIBERS',
  'NOTIFICATIONS': 'NOTIFICATIONS',

  'RECIPIENTS': 'RECIPIENTS',
  'EMAIL_DOMAINS': 'EMAIL_DOMAINS',
  'EMAIL_PROFILES': 'EMAIL_PROFILES',
  'EMAIL_SETTINGS': 'EMAIL_SETTINGS',
  'SMTP_PROFILES': 'SMTP_PROFILES',

  'CONNECTIONS': 'CONNECTIONS',
};

data.BACK_IN_STOCK_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'INVENTORY': 'INVENTORY',
  'SUBSCRIBERS': 'SUBSCRIBERS',
  'NOTIFICATIONS': 'NOTIFICATIONS',
  'EMAILS': 'EMAILS',
  'ECOMMERCE': 'ECOMMERCE',
  'CONNECTIONS': 'CONNECTIONS',
  'DATA': 'DATA',
};


data.REVIEWS_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'MANAGE_REVIEWS': 'MANAGE_REVIEWS',
  'COLLECTORS': 'COLLECTORS',
  'REVIEWS_WIDGETS': 'REVIEWS_WIDGETS',
  'STAR_RATINGS': 'STAR_RATINGS',

  'REVIEWS_EMAILS': 'REVIEWS_EMAILS',
  'EMAIL_DOMAINS': 'EMAIL_DOMAINS',
  'EMAIL_PROFILES': 'EMAIL_PROFILES',
  'EMAIL_SETTINGS': 'EMAIL_SETTINGS',
  'SMTP_PROFILES': 'SMTP_PROFILES',

  'CONNECTIONS': 'CONNECTIONS',
};

data.REVIEWS_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'MANAGE_REVIEWS': 'MANAGE_REVIEWS',
  'COLLECTORS': 'COLLECTORS',
  'WIDGETS': 'WIDGETS',
  'EMAILS': 'EMAILS',
  'ECOMMERCE': 'ECOMMERCE',
  'CONNECTIONS': 'CONNECTIONS',
  'DATA': 'DATA',
};


data.REPERKS_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',

  'EARNING_POINTS': 'EARNING_POINTS',
  'STORE_REWARDS': 'STORE_REWARDS',

  'MEMBERS': 'MEMBERS',
  'ACTIVITIES': 'ACTIVITIES',

  'EMAILS': 'EMAILS',
  'EMAIL_DOMAINS': 'EMAIL_DOMAINS',
  'EMAIL_PROFILES': 'EMAIL_PROFILES',
  'EMAIL_SETTINGS': 'EMAIL_SETTINGS',
  'SMTP_PROFILES': 'SMTP_PROFILES',

  'CONNECTIONS': 'CONNECTIONS',
};

data.REPERKS_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'PROGRAM': 'PROGRAM',
  'MEMBERS': 'MEMBERS',
  'ANALYTICS': 'ANALYTICS',
  'EMAILS': 'EMAILS',
  'ECOMMERCE': 'ECOMMERCE',
  'CONNECTIONS': 'CONNECTIONS',
  'DATA': 'DATA',
};


data.RECOMMENDER_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'RECOMMENDERS': 'RECOMMENDERS',
  'RECOMMENDER_SETTINGS': 'RECOMMENDER_SETTINGS',

  'CONNECTIONS': 'CONNECTIONS',
};

data.RECOMMENDER_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'RECOMMENDERS': 'RECOMMENDERS',
  'ECOMMERCE': 'ECOMMERCE',
  'CONNECTIONS': 'CONNECTIONS',
  'DATA': 'DATA',
};


data.PROMPT_SIDEBAR = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'PROMPTS': 'PROMPTS',

  'CONNECTIONS': 'CONNECTIONS',
};

data.PROMPT_MENU = {
  'OVERVIEW': 'OVERVIEW',
  'ANALYTICS': 'ANALYTICS',
  'PROMPTS': 'PROMPTS',
  'ECOMMERCE': 'ECOMMERCE',
  'CONNECTIONS': 'CONNECTIONS',
  'DATA': 'DATA',
};


data.PAGE_TAB = {
  'CONTACTS': {
    'ACTIVE': 'ACTIVE',
    'NON_SENDABLE': 'NON_SENDABLE',
    'SUPPRESSED': 'SUPPRESSED',
  },

  'CONTACT_ACTIVITIES': {
    'ONVOARD': 'ONVOARD',
    'EXTERNAL': 'EXTERNAL',
    'CUSTOM': 'CUSTOM',
  },

  'CONTACT_PROPERTIES': {
    'PREDEFINED': 'PREDEFINED',
    'CUSTOM': 'CUSTOM',
  },

  'EMAILS': {
    'BROADCAST': 'BROADCAST',
    'WORKFLOW': 'WORKFLOW',
  },

  'EMAIL_TEMPLATES': {
    'LIBRARY': 'LIBRARY',
    'CUSTOM': 'CUSTOM',
  },

  'PRODUCTS': {
    'PRODUCTS': 'PRODUCTS',
    'GROUPS': 'GROUPS',
    'TAGS': 'TAGS',
  },

  'REVIEWS': {
    'PRODUCT': 'PRODUCT',
    'SITE': 'SITE',
    'BIGCOMMERCE': 'BIGCOMMERCE',
  },

  'CUSTOM': {
    'PAGES': 'PAGES',
    'DOMAINS': 'DOMAINS',
  },

  'IMPORT_JOBS': {
    'IMPORT_JOBS': 'IMPORT_JOBS',
    'CSV_SCHEMAS': 'CSV_SCHEMAS',
  },

  'DATA_MAPPINGS': {
    'PREDEFINED': 'PREDEFINED',
    'CUSTOM': 'CUSTOM',
  },

  'LOOKUP_TABLES': {
    'PREDEFINED': 'PREDEFINED',
    'CUSTOM': 'CUSTOM',
  },

  'RESOURCES': {
    'ONVOARD': 'ONVOARD',
    'EXTERNAL': 'EXTERNAL',
    'CUSTOM': 'CUSTOM',
  },

  'RESOURCE_ASSOCIATIONS': {
    'PREDEFINED': 'PREDEFINED',
    'CUSTOM': 'CUSTOM',
  },

  'USAGES': {
    'USAGES': 'USAGES',
    'ALERTS': 'ALERTS',
    'RECIPIENTS_GROUPS': 'RECIPIENTS_GROUPS',
  },

  'INVOICES': {
    'INVOICES': 'INVOICES',
    'ITEMS': 'ITEMS',
  },

  'SEGMENTS': {
    'SEGMENTS': 'SEGMENTS',
    'LIBRARY': 'LIBRARY',
  },

  'WEB_TRACKING': {
    'CONFIG': 'CONFIG',
    'MANUAL_INSTALLATION': 'MANUAL_INSTALLATION',
  },

  'SHOPIFY_SETTINGS': {
    'SETTINGS': 'SETTINGS',
    'ACTIONS': 'ACTIONS',
  },

  'EASYSTORE_SETTINGS': {
    'SETTINGS': 'SETTINGS',
    'ACTIONS': 'ACTIONS',
  },

  'BIGCOMMERCE_SETTINGS': {
    'SETTINGS': 'SETTINGS',
    'ACTIONS': 'ACTIONS',
  },

  'SHOPLINE_SETTINGS': {
    'SETTINGS': 'SETTINGS',
    'ACTIONS': 'ACTIONS',
  },

  'WIX_SETTINGS': {
    'SETTINGS': 'SETTINGS',
    'ACTIONS': 'ACTIONS',
  },

  'BACK_IN_STOCK_SUBSCRIBERS': {
    'SUBSCRIBERS': 'SUBSCRIBERS',
    'SYNC_LOGS': 'SYNC_LOGS',
  },

  'AFFILIATE': {
    'PROGRAM': 'PROGRAM',
    'COUPONS': 'COUPONS',
    'REFERRALS': 'REFERRALS',
  },

  'PARTNER': {
    'OVERVIEW': 'OVERVIEW',
    'METRICS': 'METRICS',
    'COMMISSIONS': 'COMMISSIONS',
    'PAYOUTS': 'PAYOUTS',
  },

  'CONTROL_PARTNERS': {
    'PARTNERS': 'PARTNERS',
    'DEALS': 'DEALS',
    'REFERRALS': 'REFERRALS',
    'PAYOUTS': 'PAYOUTS',
  },

  'CONTROL_AGENCIES': {
    'AGENCIES': 'AGENCIES',
    'OPTIONS': 'OPTIONS',
  },

  'CONTROL_INTEGRATION_PARNTERS': {
    'INTEGRATIONS': 'INTEGRATIONS',
    'OPTIONS': 'OPTIONS',
  },
}

data.GLASSY_TAB = {
  'EMAIL': {
    'RECIPIENTS': 'RECIPIENTS',
    'ANALYTICS': 'ANALYTICS',
    'CONVERSIONS': 'CONVERSIONS',
  },

  'BACK_IN_STOCK_EMAIL': {
    'RECIPIENTS': 'RECIPIENTS',
    'ANALYTICS': 'ANALYTICS',
    'CONVERSIONS': 'CONVERSIONS',
  },

  'REVIEWS_EMAIL': {
    'RECIPIENTS': 'RECIPIENTS',
    'ANALYTICS': 'ANALYTICS',
    'CONVERSIONS': 'CONVERSIONS',
  },

  'REPERKS_EMAIL': {
    'RECIPIENTS': 'RECIPIENTS',
    'ANALYTICS': 'ANALYTICS',
    'CONVERSIONS': 'CONVERSIONS',
  },

  'CONTACT_PROFILE': {
    'OVERVIEW': 'OVERVIEW',
    'ACTIVITIES': 'ACTIVITIES',
    'ASSOCIATIONS': 'ASSOCIATIONS',
    'ORDERS': 'ORDERS',
  },

  'RECOMMENDER': {
    'ANALYTICS': 'ANALYTICS',
    'CONVERSIONS': 'CONVERSIONS',
  },

  'PROMPT': {
    'ANALYTICS': 'ANALYTICS',
    'SALES': 'SALES',
  },

  'WORKFLOW': {
    'MEMBERS': 'MEMBERS',
    'LOGS': 'LOGS',
    'ANALYTICS': 'ANALYTICS',
    'CONVERSIONS': 'CONVERSIONS',
    'EXCLUSIONS': 'EXCLUSIONS',
  },

}



// plan options
const PLAN_OPTIONS = [];
data.SILVER_PLAN_OPTIONS.forEach((option) => {
  option.package = data.SUBSCRIPTION_PACKAGE_SILVER;
  PLAN_OPTIONS.push(option);
})

data.RUBY_PLAN_OPTIONS.forEach((option) => {
  option.package = data.SUBSCRIPTION_PACKAGE_RUBY;
  PLAN_OPTIONS.push(option);
})

data.GOLD_PLAN_OPTIONS.forEach((option) => {
  option.package = data.SUBSCRIPTION_PACKAGE_GOLD;
  PLAN_OPTIONS.push(option);
})

data.GOLD_PLAN_V2_OPTIONS.forEach((option) => {
  option.package = data.SUBSCRIPTION_PACKAGE_GOLD;
  PLAN_OPTIONS.push(option);
})

data.JADE_PLAN_OPTIONS.forEach((option) => {
  option.package = data.SUBSCRIPTION_PACKAGE_JADE;
  PLAN_OPTIONS.push(option);
})

data.DIAMOND_PLAN_OPTIONS.forEach((option) => {
  option.package = data.SUBSCRIPTION_PACKAGE_DIAMOND;
  PLAN_OPTIONS.push(option);
})

data.PLAN_OPTIONS = PLAN_OPTIONS;



export default data;
